var r;!function(r){r.light="light",r.dark="dark"}(r||(r={}));export{r as SpinnerVariant};
//# sourceMappingURL=Spinner.types.js.map
